// src/pages/Contact.jsx
import React, { useState } from "react";
import { PRIMARY_COLOR, ACCENT_BG } from "../App";
import { notifyError, notifySuccess } from "../utils/notify";
import { emailConfigOk, sendContactEmail } from "../utils/email";

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!emailConfigOk) {
        notifyError(
          "Email not configured",
          "Please set EmailJS keys to send contact form submissions to info@mehartraders.co.uk."
        );
        return;
      }

      await sendContactEmail(formData);
      notifySuccess("Message sent", "We've received your enquiry at info@mehartraders.co.uk and hello@mehartradersinternational.co.uk.");
      setSubmitted(true);
      setFormData({ name: "", email: "", subject: "", message: "" });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      notifyError("Message failed", "Please try again or email info@mehartraders.co.uk or hello@mehartradersinternational.co.uk directly.");
    }
  };

  return (
    <div className="min-h-screen pt-32 bg-gray-900 text-white px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-gray-800 p-5 sm:p-8 rounded-xl shadow-2xl border border-gray-700">
        <h1
          className={`text-3xl sm:text-4xl md:text-5xl font-extrabold ${PRIMARY_COLOR} mb-6 border-b border-teal-700 pb-3`}
        >
          Get in Touch
        </h1>
        <p className="text-lg text-gray-300 mb-6 leading-relaxed">
          For all business, support, or partnership inquiries, please reach out to our professional team.
        </p>

        {/* Email Support */}
        <div className="space-y-4 mb-8">
          <p className="text-lg sm:text-xl font-semibold text-white">Email Support:</p>
          <a
            href="mailto:info@mehartraders.co.uk"
            className={`${PRIMARY_COLOR} block text-base sm:text-xl hover:text-teal-400 transition-colors break-all`}
          >
            info@mehartraders.co.uk
          </a>
          <a
            href="mailto:hello@mehartradersinternational.co.uk"
            className={`${PRIMARY_COLOR} block text-base sm:text-xl hover:text-teal-400 transition-colors break-all`}
          >
            hello@mehartradersinternational.co.uk
          </a>
        </div>

        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full p-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:ring-2 focus:ring-teal-500"
            />
          </div>

          <input
            type="text"
            name="subject"
            placeholder="Subject"
            value={formData.subject}
            onChange={handleChange}
            required
            className="w-full p-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:ring-2 focus:ring-teal-500"
          />

          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="6"
            className="w-full p-3 rounded-lg bg-gray-700 border border-gray-600 text-white focus:outline-none focus:ring-2 focus:ring-teal-500"
          />

          <button
            type="submit"
            className={`${ACCENT_BG} text-white px-6 py-3 rounded-lg font-semibold shadow-lg hover:scale-[1.02] transition-transform duration-200`}
          >
            Submit
          </button>

          {submitted && (
            <p className="text-green-400 font-medium mt-2">
              Thank you! Your message has been sent.
            </p>
          )}
        </form>
      </div>
    </div>
  );
};

export default Contact;
